import { Component, effect, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvestmentStrategyStore } from '@zero/onboarding/domain';
import { ButtonComponent, IconComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  imports: [ModalComponent, TranslocoPipe, ButtonComponent, IconComponent],
  templateUrl: './first-action-strategy-modal.component.html',
  styleUrl: './first-action-strategy-modal.component.scss',
  providers: [InvestmentStrategyStore],
})
export class FirstActionStrategyModalComponent implements OnInit {
  public readonly modal = inject(NgbActiveModal);
  public readonly store = inject(InvestmentStrategyStore);
  public readonly router = inject(Router);
  public readonly addSavingsPlanPage = commonRoutes.postlogin.add_savings_plan;

  constructor() {
    effect(() => {
      if (this.store.strategyAcknowledged()) {
        const strategy = this.store.notedStrategy();
        if (strategy?.instruments) {
          this.router.navigate([this.addSavingsPlanPage], {
            queryParams: {
              totalAmount: 0,
              isin: strategy.instruments.map((item) => item.isin).join(','),
              share: strategy.instruments.map((item) => item.weight).join(','),
            },
          });
        }
        this.modal.dismiss();
      }
    });
  }

  ngOnInit(): void {
    this.store.loadStrategies();
    this.store.loadNotedStrategy();
  }
}
